
<template>
  <b-container fluid id="news-feed">
    <div v-for="(post, index) in companyWallPosts" :key="post.url + index">
      <MemberPost
        v-if="post && post.user_details && !post.is_shared"
        :postProps="post.post_details"
        :companyDetails="companyInfo"
        :isCompanyPost="true"
        :isUserPost="
          post.post_details.customer_details.customer_id ===
          userInfo.customer_id
        "
      />
      <SharedPost
        v-if="post && post.user_details && post.is_shared"
        :postProps="post"
        :companyDetails="post.company_details"
        :isCompanyPost="true"
        :isUserPost="post.user_details.customer_id === userInfo.customer_id"
      />
    </div>
    <div class="container">
      <infinite-loading
        @infinite="infiniteHandler"
        :identifier="wallInfiniteId"
      >
        <div slot="spinner">Loading...</div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
    <go-top bg-color="#bd9d5f"></go-top>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import GoTop from '@inotom/vue-go-top';
import { v4 as uuidv4 } from 'uuid';
import MemberPost from '../../components/newsFeed/MemberPost.vue';
import SharedPost from '../../components/newsFeed/SharedPost.vue';

export default {
  name: 'CompanyWall',
  components: {
    MemberPost,
    GoTop,
    SharedPost,

  },
  data() {
    return {
      wallNextPage: false,
      wallPage: 0,
      wallInfiniteId: uuidv4,
      companyInfo: null,
      showCommentCollapse: false,
      companyId: '',
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
      companyWallPosts: 'companies/companyWall',
    }),
  },
  async created() {
    this.companyId = this.$route.params.companyId;
    this.wallPage += 1;
    const { next } = await this.companyWall({
      page: this.wallPage,
      companyId: this.companyId,
    });
    this.wallNextPage = !!next;

    this.companyInfo = await this.fetchCompany(this.companyId);
  },
  methods: {
    ...mapActions({
      companyWall: 'companies/companyWall',
      fetchCompany: 'companies/fetchCompany',
    }),
    async infiniteHandler($state) {
      try {
        if (!this.wallPage) {
          this.wallPage += 1;
          const { next } = await this.companyWall({
            page: this.wallPage,
            companyId: this.companyId,
          });
          this.wallNextPage = !!next;
          $state.loaded();
        } else if (this.wallNextPage) {
          this.wallPage += 1;
          const { next } = await this.companyWall({
            page: this.wallPage,
            companyId: this.companyId,
          });
          this.wallNextPage = !!next;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (err) {
        $state.complete();
      }
    },
  },
};
</script>

<style scoped>
#news-feed {
  margin: 0 auto;
}
#main {
  padding: 14px 16px 9px 16px;
}
.post-user-img > img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.post-username {
  font-weight: bold;
  text-transform: capitalize;
  font-size: 12px;
}
.post-user-position {
  text-transform: capitalize;
  color: #666666;
  font-size: 10px;
}
.post-company-name {
  color: #bd9d5f;
}
.post-created-time {
  color: #9c9999;
  font-size: 10px;
  line-height: 1;
}
.shared-post-cont {
  background-color: white;
  border: 1px solid rgb(230, 228, 228);
  margin-bottom: 20px;
}
.shared-post-user-cont {
  display: flex;
}
.load-posts {
  width: 25%;
  background: none;
  border: 1px solid #bd9d5f;
  color: #bd9d5f;
  font-size: 12px;
  margin-bottom: 25px;
}
.load-posts:hover {
  background-color: #bd9d5f;
  color: white;
  transition: 0.5s;
}
.post-comment-text-p {
  border-bottom: 1px solid #ebebeb;
  margin-top: 0;
  font-size: 12px;
  margin-bottom: 0;
}
.post-like-comment-share {
  display: flex;
  color: #666666;
  padding: 10px;
}
.post-share-component {
  display: flex;
  align-items: flex-end;
}
.post-comment-btn {
  font-size: 12px;
  background: #faebd700;
  border: navajowhite;
  color: gray;
  padding: 7px 10px 6px 10px;
  margin-right: 7px;
  outline: none;
  border-radius: unset;
}
.post-comment-btn:hover {
  color: white;
  background: #bd9d5f;
  transition: 0.5s;
}
.post-comment-btn:focus {
  outline: 0 !important;
  box-shadow: none;
}
</style>
